import useAsyncData from "../../../../../hooks/use-async-data";
import metaService from "../../../meta.service";
import MetaBillingsCargoTaxiStatusCounters from "./meta-billings-cargo-taxi-status-counters";
import MetaBillingsCargoTaxiStatusCountersParams from "./meta-billings-cargo-taxi-status-counters-params";

const useMetaBillingsCargoTaxiStatusCounters = () => {
  const { data, setData, isLoading, setIsLoading, isError, setIsError } =
    useAsyncData<MetaBillingsCargoTaxiStatusCounters | null>(null);

  const load = async (
    params: MetaBillingsCargoTaxiStatusCountersParams,
    abortSignal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await metaService.getCargoTaxiStatusCounters(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useMetaBillingsCargoTaxiStatusCounters;
